/* EasyExhibition – Landingpage „LED-Messestand kaufen“ (Funnel).
   Verbindet alle lf-*-Sections: Konfigurator in 3 Schritten, Live-Preis, 3D (ledup-3d),
   Liefertermin-Check, Miet-Vergleich, Bewertungen (Judge.me), Galerie, Video, Leiste unten (mobil)
   und das Absenden an den Angebots-Server. Keine Abhängigkeiten; Preise kommen aus ledup-pricing.js. */
(function () {
  'use strict';

  var EUR = function (n) { return Math.round(n).toLocaleString('de-DE') + ' €'; };
  var NUM = function (n) { return String(Math.round(n * 100) / 100).replace('.', ','); };
  var WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }
  function isMobile() { return window.matchMedia('(max-width: 989px)').matches; }
  function reduceMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  /* Bild verkleinern und als JPEG kodieren (für den Versand an den Angebots-Server) */
  function downscale(dataUrl, max, quality) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var f = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * f);
        c.height = Math.round(img.height * f);
        var g = c.getContext('2d');
        g.fillStyle = '#fff';
        g.fillRect(0, 0, c.width, c.height);
        g.drawImage(img, 0, 0, c.width, c.height);
        try { resolve(c.toDataURL('image/jpeg', quality)); } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = dataUrl;
    });
  }

  /* ------------------------------------------------------------------ Konfiguration & Zustand */
  var cfgEl = document.getElementById('lf-config');
  var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }
  cfg.leadApi = String(cfg.leadApi || '').trim();
  cfg.pricing = cfg.pricing || {};
  cfg.delivery = cfg.delivery || { ok: 9, express: 5 };
  cfg.vis = cfg.vis || { mode: 'manuell', eta: 'innerhalb von 24 Stunden' };
  cfg.saveApi = cfg.leadApi ? cfg.leadApi.replace(/\/api\/lead\/?$/, '/api/entwurf') : '';
  var start = cfg.start || {};

  var st = {
    typ: start.typ || 'kopf',
    breite: parseInt(start.breite, 10) || 3,
    tiefen: { eck: 3, reihe: 1 },
    theke: 'none', thekeN: 1, br: false, kab: false, kabT: 1, tv: false,
    licht: true, masse: false, spiegeln: false,
    img: '', imgDemo: false, logo: '', logoName: '',
    step: 1, messe: '', xlOpen: false,
    sending: false, sent: false, who: { name: '', email: '' }
  };
  if (cfg.demos && cfg.demos.length) { st.img = cfg.demos[0]; st.imgDemo = true; }

  function P() { return window.LedupPricing; }
  function konfig(over) {
    var k = {
      typ: st.typ, breite: st.breite, tiefe: st.typ === 'kopf' ? 0 : st.tiefen[st.typ],
      theke: st.theke, thekeAnzahl: st.thekeN, bruecke: st.br, kabine: st.kab, kabineTiefe: st.kabT, tv: st.tv
    };
    return over ? Object.assign(k, over) : k;
  }
  function quote(k) { return P().quote(k, cfg.pricing); }

  /* Fertige Konfiguration übernehmen (Vorlage oder Link ?konfig=…) */
  function applyConfig(c) {
    if (!c || !P()) return;
    var k = P().normalize(c);
    st.typ = k.typ;
    st.breite = k.breite;
    if (k.typ !== 'kopf') st.tiefen[k.typ] = k.tiefe;
    st.theke = k.theke;
    st.thekeN = k.thekeAnzahl || 1;
    st.br = k.bruecke;
    st.kab = k.kabine;
    st.kabT = k.kabineTiefe || 1;
    st.tv = k.tv;
    konfigTouched = true;
  }
  function konfigCode(k) { return P() && P().encodeKonfig ? P().encodeKonfig(k) : ''; }

  function derive() {
    if (!P()) return null;
    var q = quote(konfig());
    var k = q.config;
    var addons = [];
    if (k.theke === 'one') addons.push('counter-one');
    if (k.theke === 'counter') addons.push('counter');
    if (k.bruecke) addons.push('bruecke');
    if (k.kabine) addons.push('kabine');
    if (k.tv) addons.push('tv');
    var rentPct = Number(cfg.pricing.rentPct) || 45;
    var rent = Math.ceil(q.netTotal * rentPct / 100 / 50) * 50;
    return {
      q: q, k: k, addons: addons, price: q.netTotal, reprint: q.reprintNet,
      masz: q.masz, typName: q.typName, extras: q.extras, qm: q.wallSqm,
      kabOff: st.typ === 'kopf' || st.breite < 3, rent: rent
    };
  }

  // Aufpreis einer Option gegenüber „ohne“ – bei der aktuellen Konfiguration
  function deltas() {
    var none = { theke: 'none' };
    var base = quote(konfig(none)).netTotal;
    return {
      'theke:counter': quote(konfig({ theke: 'counter' })).netTotal - base,
      'theke:one': quote(konfig({ theke: 'one' })).netTotal - base,
      br: quote(konfig({ bruecke: true })).netTotal - quote(konfig({ bruecke: false })).netTotal,
      kab: quote(konfig({ kabine: true })).netTotal - quote(konfig({ kabine: false })).netTotal,
      tv: quote(konfig({ tv: true })).netTotal - quote(konfig({ tv: false })).netTotal
    };
  }

  /* ------------------------------------------------------------------ Liefertermin-Check */
  // Werktage Mo–Fr; Feiertage sind nicht berücksichtigt – die Texte sagen deshalb „voraussichtlich“.
  function isWork(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addWork(d, n) {
    var x = new Date(d), step = n < 0 ? -1 : 1;
    n = Math.abs(n);
    while (n > 0) { x.setDate(x.getDate() + step); if (isWork(x)) n--; }
    return x;
  }
  function workBetween(a, b) {
    var n = 0, x = new Date(a);
    x.setDate(x.getDate() + 1);
    while (x < b) { if (isWork(x)) n++; x.setDate(x.getDate() + 1); }
    return n;
  }
  function fmtDate(d) { return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear(); }
  function fmtDay(d) { return WD[d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }

  function lieferCheck(value) {
    if (!value) return null;
    var m = new Date(value + 'T00:00:00');
    if (isNaN(m.getTime())) return null;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var dl = cfg.delivery;
    if (m <= today) return { s: 'bad', t: 'Bitte wählen Sie ein Datum in der Zukunft.', label: '' };
    var okDays = Number(dl.ok) || 9;                  // grün: mind. so viele Werktage bis zur Messe
    var orderBy = addWork(m, -(okDays + 1));          // letzter Bestelltag, an dem es noch grün ist
    var avail = workBetween(today, m);
    if (avail >= okDays) {
      return {
        s: 'ok',
        t: 'Passt: Bei Bestellung bis ' + fmtDay(orderBy) + ' ist Ihr Stand voraussichtlich rechtzeitig da – auf Wunsch direkt an die Messe.',
        label: fmtDate(m) + ' – passt (bestellen bis ' + fmtDate(orderBy) + ')'
      };
    }
    if (avail >= (Number(dl.express) || 5)) {
      return { s: 'warn', t: 'Knapp, aber mit Express machbar. Senden Sie die Anfrage – wir melden uns schnellstmöglich.', label: fmtDate(m) + ' – knapp, Express nötig' };
    }
    return { s: 'bad', t: 'Sehr knapp. Rufen Sie uns bitte direkt an – wir prüfen sofort, was möglich ist.', label: fmtDate(m) + ' – sehr knapp, bitte anrufen', call: true };
  }

  function renderCheck(res) {
    $$('[data-lf-check-out]').forEach(function (out) {
      if (!res) { out.hidden = true; out.innerHTML = ''; return; }
      out.hidden = false;
      out.className = 'lf-check lf-check--' + res.s;
      out.innerHTML = '';
      var ico = res.s === 'ok'
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.7 2.7L16.2 9.5"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5l9.5 16.5h-19z"/><path d="M12 10v4.5M12 17.5v.01"/></svg>';
      out.insertAdjacentHTML('beforeend', ico);
      var span = el('span', '', res.t + (res.call && cfg.phone ? ' ' : ''));
      if (res.call && cfg.phone) {
        var a = el('a', '', cfg.phone);
        a.href = cfg.telHref || ('tel:' + cfg.phone.replace(/\s/g, ''));
        a.setAttribute('data-lf-track', 'phone');
        span.appendChild(a);
      }
      out.appendChild(span);
      out.setAttribute('role', 'status');
    });
  }

  /* ------------------------------------------------------------------ Render */
  function render() {
    var d = derive();
    if (!d) return;

    /* 3D */
    var v = $('ledup-3d');
    if (v) {
      v.setAttribute('typ', st.typ);
      v.setAttribute('breite', String(st.breite));
      if (d.k.tiefe) v.setAttribute('tiefe', String(d.k.tiefe)); else v.removeAttribute('tiefe');
      v.setAttribute('masse', st.masse ? 'on' : 'off');
      v.setAttribute('spiegeln', st.spiegeln ? 'on' : 'off');
      v.setAttribute('licht', st.licht ? 'on' : 'off');
      v.setAttribute('image', st.img || '');
      v.setAttribute('addons', d.addons.join(','));
      v.setAttribute('theken', String(d.k.thekeAnzahl || 1));
      v.setAttribute('kabine-tiefe', String(d.k.kabineTiefe || 1));
    }
    setText('[data-lf-lightlabel]', st.licht ? 'Licht aus' : 'Licht an');
    $$('[data-lf-masse]').forEach(function (b) { b.setAttribute('aria-pressed', st.masse ? 'true' : 'false'); });
    $$('[data-lf-mirror]').forEach(function (b) { b.setAttribute('aria-pressed', st.spiegeln ? 'true' : 'false'); });
    $$('[data-lf-noimage]').forEach(function (e) { e.hidden = !st.imgDemo; });
    $$('[data-lf-demo]').forEach(function (b) { b.setAttribute('aria-pressed', st.imgDemo && b.getAttribute('data-lf-demo') === st.img ? 'true' : 'false'); });

    /* Eingaben synchron halten */
    $$('[data-lf-typ]').forEach(function (r) { r.checked = r.value === st.typ; });
    $$('[data-lf-breite]').forEach(function (r) { r.checked = parseInt(r.value, 10) === st.breite; });
    // Sonderlänge 7–10 m: hinter dem „+“, offen solange gewählt
    var xl = st.breite > 6;
    $$('[data-lf-breite-xl]').forEach(function (w) { w.hidden = !(xl || st.xlOpen); });
    $$('[data-lf-breite-more]').forEach(function (b) {
      b.setAttribute('aria-expanded', xl || st.xlOpen ? 'true' : 'false');
      b.classList.toggle('is-on', xl);
    });
    setText('[data-lf-breite-more-label]', xl ? st.breite + ' m' : '+');
    $$('[data-lf-tiefe-wrap]').forEach(function (w) { w.hidden = !d.k.tiefe; });
    $$('[data-lf-tiefe]').forEach(function (r) {
      var t = parseInt(r.value, 10);
      r.checked = t === d.k.tiefe;
      if (r.parentNode) r.parentNode.hidden = t > d.k.maxTiefe;
    });
    $$('[data-lf-theke]').forEach(function (r) { r.checked = r.value === st.theke; });
    // Anzahl Theken (1–3, je nach Frontbreite)
    if (d.k.thekeAnzahl) st.thekeN = d.k.thekeAnzahl;
    $$('[data-lf-theke-n-wrap]').forEach(function (w) { w.hidden = st.theke === 'none'; });
    $$('[data-lf-theke-n]').forEach(function (r) {
      var n = parseInt(r.value, 10);
      r.disabled = n > d.k.maxTheken;
      r.checked = n === (d.k.thekeAnzahl || 1);
    });
    setText('[data-lf-theke-n-note]', d.k.maxTheken < 3 ? (d.k.maxTheken === 1 ? '2 Theken ab 3 m, 3 ab 4 m Frontbreite' : '3 Theken ab 4 m Frontbreite') : 'werden auf dem Stand verteilt');
    // Kabinengröße (1 × 2 m ab 2 m Standtiefe)
    if (d.k.kabine) st.kabT = d.k.kabineTiefe;
    $$('[data-lf-kab-t-wrap]').forEach(function (w) { w.hidden = !d.k.kabine; });
    $$('[data-lf-kab-t]').forEach(function (r) {
      var n = parseInt(r.value, 10);
      r.disabled = n === 2 && d.k.tiefe < 2;
      r.checked = n === (d.k.kabineTiefe || 1);
    });
    setText('[data-lf-kab-t-note]', d.k.tiefe < 2 ? '1 × 2 m ab 2 m Standtiefe' : 'Tür sitzt bei 1 × 2 m weiter vorn');
    $$('[data-lf-addon="br"]').forEach(function (c) { c.checked = d.k.bruecke; });
    $$('[data-lf-addon="tv"]').forEach(function (c) { c.checked = d.k.tv; });
    $$('[data-lf-addon="kab"]').forEach(function (c) { c.disabled = d.kabOff; c.checked = d.k.kabine; });
    setText('[data-lf-kabnote]', d.kabOff
      ? 'Ab Reihen- oder Eckstand mit 3 m Frontbreite möglich'
      : 'Abstellraum mit Tür für Jacken, Taschen und Material');

    /* Aufpreise */
    var dl = deltas();
    $$('[data-lf-delta]').forEach(function (e) {
      var key = e.getAttribute('data-lf-delta');
      var val = dl[key];
      if (key === 'kab' && d.kabOff) { e.textContent = '–'; return; }
      e.textContent = val > 0 ? '+ ' + EUR(val) : 'inklusive';
    });

    /* Maße, Preis, Zusammenfassung */
    setText('[data-lf-masz]', d.masz);
    setText('[data-lf-masz-short]', d.masz.split(' · ')[0]);
    setText('[data-lf-price]', EUR(d.price));
    setText('[data-lf-extras]', 'Höhe 2,48 m · ' + (d.extras.length ? 'mit ' + d.extras.join(', ') : 'ohne Extras'));
    var area = st.typ === 'kopf'
      ? st.breite + ' m Front · ' + NUM(d.qm) + ' m² Leuchtfläche'
      : st.breite + ' × ' + d.k.tiefe + ' m Standfläche · ' + NUM(d.qm) + ' m² Leuchtfläche';
    setText('[data-lf-area]', area);
    setText('[data-lf-stepval="1"]', st.typ === 'kopf' ? st.breite + ' m ' + d.typName : st.breite + ' × ' + d.k.tiefe + ' m ' + d.typName);
    setText('[data-lf-stepval="2"]', d.extras.length ? d.extras.length + (d.extras.length === 1 ? ' Extra' : ' Extras') : 'Keine Extras');
    setText('[data-lf-stepval="3"]', st.sent ? 'Gesendet' : 'Kostenlos');
    var code = konfigCode(konfig());
    $$('[data-lf-preset]').forEach(function (b) { b.setAttribute('aria-pressed', b.__code && b.__code === code ? 'true' : 'false'); });
    renderLogo();
    var hidden = $('[data-lf-hidden-konfig]');
    if (hidden) {
      hidden.value = d.masz + ' | ' + NUM(d.qm) + ' m²'
        + (d.extras.length ? ' | Zubehör: ' + d.extras.join(', ') : '')
        + ' | angezeigter Preis: ' + EUR(d.price) + ' netto'
        + (st.img && !st.imgDemo ? ' | eigenes Design getestet' : '');
    }

    /* Schritte */
    $$('[data-lf-step]').forEach(function (s) { s.hidden = st.sent || parseInt(s.getAttribute('data-lf-step'), 10) !== st.step; });
    $$('[data-lf-stepbtn]').forEach(function (b) {
      var n = parseInt(b.getAttribute('data-lf-stepbtn'), 10);
      if (n === st.step && !st.sent) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.classList.toggle('is-done', st.sent || n < st.step);
      b.disabled = st.sent;
    });
    var next = $('[data-lf-next]');
    var footSubmit = $('.lf-panel__foot [data-lf-submit]');
    var foot = $('[data-lf-foot]');
    if (foot) foot.hidden = st.sent;
    if (next) {
      next.hidden = st.step === 3;
      next.textContent = st.step === 1 ? 'Weiter: Ausstattung' : 'Weiter: Visualisierung';
    }
    if (footSubmit) footSubmit.hidden = st.step !== 3;
    $$('[data-lf-submit]').forEach(function (b) {
      if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.textContent.trim());
      b.disabled = st.sending;
      b.textContent = st.sending ? 'Wird gesendet …' : b.getAttribute('data-label');
    });

    /* Liefer-Check */
    var res = lieferCheck(st.messe);
    renderCheck(res);
    $$('[data-lf-messe]').forEach(function (i) { if (i.value !== st.messe) i.value = st.messe; });
    var hm = $('[data-lf-hidden-messe]');
    if (hm) hm.value = res && res.label ? res.label : '';

    /* Miet-Vergleich (Einwände-Karte) */
    renderRent(d);

    /* Leiste unten */
    updateBar(d);
  }

  function renderRent(d) {
    if (!$('[data-lf-rent]')) return;
    var rent3 = d.rent * 3;
    var buy3 = d.price + d.reprint;               // Kauf + neue Grafik zur 3. Messe
    var n = d.rent > 0 ? Math.floor(d.price / d.rent) + 1 : 0;   // ab dieser Messe ist Kaufen günstiger
    if (n < 2) n = 2;
    var max = Math.max(rent3, buy3) || 1;
    setText('[data-lf-rent-n]', String(n));
    setText('[data-lf-rent-config]', d.masz.split(' · ')[0]);
    setText('[data-lf-rent-rent]', 'ca. ' + EUR(rent3));
    setText('[data-lf-rent-buy]', EUR(buy3));
    var save = rent3 - buy3;
    setText('[data-lf-rent-save]', save > 0 ? 'Rund ' + EUR(Math.round(save / 50) * 50) + ' gespart – nach nur drei Messen.' : 'Ab der ' + n + '. Messe günstiger als Mieten.');
    $$('[data-lf-rent-bar="rent"]').forEach(function (b) { b.style.width = (rent3 / max * 100).toFixed(1) + '%'; });
    $$('[data-lf-rent-bar="buy"]').forEach(function (b) { b.style.width = (buy3 / max * 100).toFixed(1) + '%'; });
  }

  function fillFromPrices() {
    if (!P()) return;
    $$('[data-lf-from]').forEach(function (e) {
      var p = (e.getAttribute('data-lf-from') || 'kopf,2,0').split(',');
      e.textContent = EUR(quote({ typ: p[0], breite: p[1], tiefe: p[2] }).netTotal);
    });
    ['kopf', 'reihe', 'eck'].forEach(function (t) {
      var min = quote({ typ: t, breite: 2, tiefe: 1 }).netTotal;
      setText('[data-lf-typfrom="' + t + '"]', EUR(min));
    });
    $$('[data-lf-preset]').forEach(function (b) {
      var c = presetOf(b);
      if (!c) return;
      var q = quote(c);
      b.__code = konfigCode(q.config);
      var pr = $('[data-lf-preset-price]', b);
      if (pr) pr.textContent = EUR(q.netTotal);
      var desc = $('[data-lf-preset-desc]', b);
      if (desc && !desc.textContent.trim()) desc.textContent = q.masz.split(' · ')[0] + (q.extras.length ? ' · ' + q.extras.join(', ') : '');
    });
  }
  function presetOf(b) { try { return JSON.parse(b.getAttribute('data-lf-preset')); } catch (e) { return null; } }

  /* ------------------------------------------------------------------ Schritte & Scrollen */
  function scrollToEl(target, offset) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - (offset || 0);
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion() ? 'auto' : 'smooth' });
  }
  function headerOffset() {
    if (document.body.classList.contains('lf-page')) return 0; // Header klebt hier nicht
    var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return h;
  }
  function scrollToPanel() {
    var panel = $('[data-lf-panel]');
    if (!panel) return;
    if (isMobile()) {
      var stage = $('.lf-konf__stagecol');
      var sh = stage ? stage.getBoundingClientRect().height : 0;
      scrollToEl(panel, sh + 8);
    } else {
      // Desktop: nur scrollen, wenn die Panel-Oberkante nicht ohnehin oben im Bild ist
      var r = panel.getBoundingClientRect();
      if (r.top < headerOffset() + 8 || r.top > window.innerHeight * 0.45) scrollToEl(panel, headerOffset() + 24);
    }
  }

  function goStep(n, opts) {
    if (st.sent) return;
    n = Math.max(1, Math.min(3, n));
    var changed = n !== st.step;
    st.step = n;
    render();
    if (changed) track('lk_step', { step: n });
    if (opts && opts.scroll) scrollToPanel();
    var f = $('[data-lf-step="' + n + '"] .lf-step__focus');
    if (f && opts && opts.focus) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }

  function gotoTarget(name) {
    if (name === 'konfigurator') {
      // direkt zur Arbeitsfläche (3D + Schritte) – die Überschrift kennt man dann schon
      var grid = $('.lf-konf__grid') || $('#konfigurator');
      scrollToEl(grid, isMobile() ? 8 : headerOffset() + 24);
      if (!window.__lk3dLoaded) window.dispatchEvent(new Event('scroll'));
    } else if (name === 'angebot') {
      goStep(3, { scroll: true, focus: true });
    } else {
      var t = document.getElementById(name);
      scrollToEl(t, headerOffset() + 16);
    }
  }

  /* ------------------------------------------------------------------ Leiste unten (mobil) */
  var barVis = { hero: true, konf: false, form: false, focus: false, fin: false };
  var konfigTouched = false;
  function updateBar(d) {
    var bar = $('[data-lf-bar]');
    if (!bar) return;
    d = d || derive();
    var mode = 'none';
    if (!st.sent && !barVis.focus) {
      // Desktop: im Konfigurator übernimmt der Panel-Fuß (Preis + Weiter)
      if (barVis.konf) mode = (!isMobile() || (st.step === 3 && barVis.form)) ? 'none' : 'konf';
      else if (!barVis.hero && !barVis.fin) mode = 'cta';
    }
    bar.setAttribute('data-mode', mode);
    var on = mode !== 'none';
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    $$('a, button', bar).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
    document.body.classList.toggle('lf-bar-on', on);
    var btn = $('[data-lf-bar-btn]', bar);
    var price = $('[data-lf-bar-price]', bar);
    var note = $('[data-lf-bar-note]', bar);
    if (!d) return;
    var lead = $('[data-lf-bar-lead]', bar);
    if (mode === 'cta' && konfigTouched) {
      // schon konfiguriert → eigene Auswahl zeigen statt „ab“-Preis
      if (price) price.textContent = EUR(d.price);
      if (note) note.textContent = 'netto, komplett';
      if (lead) { lead.firstChild.textContent = 'Ihr Stand'; lead.lastChild.textContent = d.masz.split(' · ')[0]; }
      if (btn) btn.textContent = 'Weiter planen';
    } else if (mode === 'cta') {
      var from = $('[data-lf-from]');
      if (price) price.textContent = 'ab ' + (from ? from.textContent : EUR(d.price));
      if (note) note.textContent = 'netto · Visualisierung gratis';
      if (btn) btn.textContent = 'Stand planen';
    } else {
      if (price) price.textContent = EUR(d.price);
      if (note) note.textContent = st.step === 1 ? d.masz.split(' · ')[0] : 'netto · inkl. Druck';
      if (btn) btn.textContent = st.step === 1 ? 'Weiter: Ausstattung' : st.step === 2 ? 'Weiter: Visualisierung' : 'Visualisierung anfordern';
    }
  }

  function initBar() {
    var bar = $('[data-lf-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = $('[data-lf-hero-cta]');
    var konf = $('[data-lf-panel]');
    var form = $('[data-lf-form]');
    if (hero) new IntersectionObserver(function (en) { barVis.hero = en[0].isIntersecting; updateBar(); }).observe(hero);
    else barVis.hero = false;
    if (konf) new IntersectionObserver(function (en) { barVis.konf = en[0].isIntersecting; updateBar(); }, { rootMargin: '0px 0px -25% 0px' }).observe(konf);
    if (form) new IntersectionObserver(function (en) { barVis.form = en[0].isIntersecting; updateBar(); }, { threshold: 0.2 }).observe(form);
    var fin = $('[data-lf-final]');
    if (fin) new IntersectionObserver(function (en) { barVis.fin = en[0].isIntersecting; updateBar(); }).observe(fin);
    // Tastatur offen (Eingabefeld fokussiert): Leiste weg, damit sie nichts verdeckt
    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('.lf input:not([type=radio]):not([type=checkbox]), .lf select, .lf textarea')) { barVis.focus = true; updateBar(); }
    });
    document.addEventListener('focusout', function () { setTimeout(function () { barVis.focus = false; updateBar(); }, 50); });
    $('[data-lf-bar-btn]', bar).addEventListener('click', function () {
      var mode = bar.getAttribute('data-mode');
      if (mode === 'cta') { gotoTarget('konfigurator'); track('lk_bar_click', { mode: 'cta' }); return; }
      if (st.step < 3) goStep(st.step + 1, { scroll: true });
      else { var f = $('[data-lf-form]'); scrollToPanel(); if (f) setTimeout(function () { var i = $('input:invalid', f) || $('input', f); if (i) i.focus(); }, 350); }
    });
  }

  /* ------------------------------------------------------------------ Design-Upload */
  var UPLOAD_MAX_MB = 25, PREVIEW_MAX_PX = 2048;
  function readFile(f) {
    var note = $('[data-lf-upload-note]');
    var say = function (txt, err) { if (!note) return; note.textContent = txt; note.classList.toggle('is-error', !!err); };
    if (!f) return;
    if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { say('Bitte ein JPG, PNG oder WebP wählen (PDF/AI schicken Sie uns später für den Druck).', true); return; }
    if (f.size > UPLOAD_MAX_MB * 1024 * 1024) { say('Die Datei ist größer als ' + UPLOAD_MAX_MB + ' MB – für die Vorschau reicht eine kleinere Version.', true); return; }
    say('Motiv wird geladen …');
    var url = URL.createObjectURL(f);
    var keepPng = f.type === 'image/png';
    var img = new Image();
    img.onload = function () {
      var sc = Math.min(1, PREVIEW_MAX_PX / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * sc));
      c.height = Math.max(1, Math.round(img.height * sc));
      var g = c.getContext('2d');
      if (!keepPng) { g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); }
      g.drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var data;
      try { data = keepPng ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.9); } catch (e) { data = null; }
      if (!data) { say('Das Bild konnte nicht gelesen werden.', true); return; }
      st.img = data; st.imgDemo = false;
      render();
      track('lk_design_upload');
      say('✓ ' + f.name + ' – so sieht Ihr Motiv auf dem Stand aus.');
    };
    img.onerror = function () { URL.revokeObjectURL(url); say('Das Bild konnte nicht gelesen werden.', true); };
    img.src = url;
  }

  /* Logo für die Visualisierung (Schritt 3) – bleibt als PNG mit Transparenz erhalten */
  function readLogo(f) {
    var p = $('[data-lf-logo-p]');
    var say = function (txt, err) { if (p) { p.textContent = txt; p.classList.toggle('is-error', !!err); } };
    if (!f) return;
    if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { say('Bitte ein PNG, JPG oder WebP wählen – SVG/PDF schicken Sie uns später für den Druck.', true); return; }
    if (f.size > 15 * 1024 * 1024) { say('Die Datei ist zu groß (max. 15 MB).', true); return; }
    var url = URL.createObjectURL(f);
    var img = new Image();
    img.onload = function () {
      var sc = Math.min(1, 1200 / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.width * sc));
      c.height = Math.max(1, Math.round(img.height * sc));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var data = null;
      try { data = c.toDataURL('image/png'); } catch (e) {}
      if (!data || data.length > 2.6 * 1024 * 1024) { try { data = c.toDataURL('image/jpeg', 0.9); } catch (e) { data = null; } }
      if (!data) { say('Das Bild konnte nicht gelesen werden.', true); return; }
      st.logo = data; st.logoName = f.name;
      render();
      track('lk_logo_upload');
    };
    img.onerror = function () { URL.revokeObjectURL(url); say('Das Bild konnte nicht gelesen werden.', true); };
    img.src = url;
  }
  function renderLogo() {
    var box = $('[data-lf-logo]');
    if (!box) return;
    var thumb = $('[data-lf-logo-thumb]', box), h = $('[data-lf-logo-h]', box), p = $('[data-lf-logo-p]', box), btn = $('[data-lf-logo-btn]', box);
    box.classList.toggle('has-logo', !!st.logo);
    if (st.logo) {
      if (thumb && thumb.getAttribute('data-src') !== st.logo) { thumb.innerHTML = ''; var i = el('img'); i.src = st.logo; i.alt = ''; thumb.appendChild(i); thumb.setAttribute('data-src', st.logo); }
      if (h) h.textContent = 'Ihr Logo ist dabei';
      if (p && !p.classList.contains('is-error')) p.textContent = st.logoName || 'Logo';
      if (btn) btn.textContent = 'Ändern';
    }
    var own = $('[data-lf-own-design]');
    if (own) own.hidden = !(st.img && !st.imgDemo);
  }

  /* Website-Feld: Vorschlag aus der Firmen-Mailadresse */
  var FREEMAIL = /@(gmail|googlemail|gmx|web|t-online|outlook|hotmail|live|msn|yahoo|icloud|me|mac|aol|freenet|posteo|mailbox|mail|proton|protonmail|arcor|online|1und1|vodafone|email)\./i;
  function suggestWebsite(email) {
    var w = $('[data-lf-website]');
    if (!w || w.value) return;
    var dom = (String(email || '').split('@')[1] || '').trim().toLowerCase();
    w.placeholder = dom && dom.indexOf('.') > 0 && !FREEMAIL.test('@' + dom) ? 'www.' + dom.replace(/^www\./, '') : 'www.ihre-firma.de';
  }

  /* ------------------------------------------------------------------ Kampagnen-Quelle */
  function fillSource() {
    var input = $('[data-lf-source]');
    if (!input) return;
    var src = '';
    try {
      var params = new URLSearchParams(window.location.search), parts = [];
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'gbraid', 'wbraid'].forEach(function (k) {
        var v = params.get(k);
        if (v) parts.push(k + '=' + v);
      });
      if (parts.length) { src = parts.join(' | '); sessionStorage.setItem('lk_source', src); }
      else src = sessionStorage.getItem('lk_source') || '';
      // Klick auf eine Anzeige bei einem früheren Besuch (lead-quelle, 90 Tage) – damit Verkäufe hochgeladen werden können
      if (!/gclid|gbraid|wbraid/.test(src)) {
        var ee = JSON.parse(localStorage.getItem('ee_src') || '{}');
        if (ee.clickId) src = (src ? src + ' | ' : '') + ee.clickId + ' | früherer Anzeigenklick ' + new Date(ee.clickAt).toLocaleDateString('de-DE');
        else if (!src && ee.last && ee.last.src) src = ee.last.src;
      }
    } catch (e) {}
    if (!src && document.referrer) src = 'referrer=' + document.referrer;
    input.value = src || 'direkt';
  }

  /* ------------------------------------------------------------------ Absenden */
  function submit(e) {
    e.preventDefault();
    var form = $('[data-lf-form]');
    if (!form || st.sending) return;
    form.classList.add('is-tried');
    if (!form.checkValidity()) {
      var bad = $(':invalid', form);
      if (bad) { bad.focus(); if (typeof form.reportValidity === 'function') form.reportValidity(); }
      return;
    }
    var d = derive();
    track('lk_form_submit', { konfiguration: d ? d.masz : '' });
    var fd = new FormData(form);
    try {
      var ud = {};
      var em = String(fd.get('contact[email]') || '').trim().toLowerCase();
      var ph = String(fd.get('contact[phone]') || '').replace(/[^\d+]/g, '');
      if (em) ud.email = em;
      if (ph) ud.phone_number = ph.charAt(0) === '0' ? '+49' + ph.slice(1) : ph;
      sessionStorage.setItem('lk_ud', JSON.stringify(ud));
    } catch (err) {}
    if (!cfg.leadApi) { fallbackSubmit(form); return; }

    var errBox = $('[data-lf-error]');
    if (errBox) errBox.hidden = true;
    var stand = null;
    var viewer = $('ledup-3d');
    try { if (viewer && typeof viewer.snapshot === 'function') stand = viewer.snapshot({ width: 1600, height: 1000 }); } catch (err) {}

    st.sending = true;
    render();
    var ownImg = st.imgDemo ? '' : st.img;
    var designP = ownImg && ownImg.indexOf('data:') === 0
      ? downscale(ownImg, 1600, 0.85)
      : Promise.resolve(ownImg ? (ownImg.indexOf('//') === 0 ? 'https:' + ownImg : ownImg) : null);
    var hp = $('[data-lf-hp]');
    var payload;

    designP.then(function (design) {
      var web = String(fd.get('contact[website]') || '').trim();
      if (!web) { var wi = $('[data-lf-website]'); if (wi && /^www\./.test(wi.placeholder || '')) web = wi.placeholder; }
      payload = {
        firma: fd.get('contact[company]') || '',
        name: fd.get('contact[name]') || '',
        email: fd.get('contact[email]') || '',
        telefon: fd.get('contact[phone]') || '',
        website: web,
        messetermin: fd.get('contact[messetermin]') || '',
        videocall: false,
        terminLabel: '',
        visMode: cfg.vis.mode,
        quelle: fd.get('contact[quelle]') || '',
        seite: window.location.href,
        consent: true,
        hp: hp ? hp.value : '',
        konfiguration: konfig(),
        gespiegelt: !!st.spiegeln,
        standBild: stand,
        designBild: design,
        logoBild: st.logo || null
      };
      st.who = { name: String(payload.name), email: String(payload.email) };
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 30000);
      return fetch(cfg.leadApi, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        clearTimeout(timer);
        return r.json().catch(function () { return {}; }).then(function (body) {
          if (!r.ok || !body.ok) { var ex = new Error(body.error || 'http ' + r.status); ex.status = r.status; throw ex; }
          return body;
        });
      });
    }).then(function (res) {
      st.sending = false;
      st.sent = true;
      var ud2 = {};
      try { ud2 = JSON.parse(sessionStorage.getItem('lk_ud') || '{}'); sessionStorage.removeItem('lk_ud'); } catch (err) {}
      track('lk_lead', { lead_type: 'messestand_angebot', user_data: ud2, value: res.netTotal, vis_mode: cfg.vis.mode, logo: st.logo ? 'ja' : 'nein' });
      if (typeof window.loadGTM === 'function') window.loadGTM();
      if (cfg.adsSendTo && typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: cfg.adsSendTo });
      showSent(res, payload.email);
    }).catch(function (x) {
      st.sending = false;
      render();
      if (x && x.status === 400 && errBox) { errBox.hidden = false; errBox.textContent = x.message; return; }
      // Server nicht erreichbar → Notfall-Weg über das Shopify-Kontaktformular, damit kein Lead verloren geht
      fallbackSubmit(form);
    });
  }

  function showSent(res, email) {
    render();
    var sent = $('[data-lf-sent]');
    if (!sent) return;
    sent.hidden = false;
    var mailed = $('[data-lf-sent-mailed]'), def = $('[data-lf-sent-default]');
    if (res && res.customerMailed) {
      if (mailed) mailed.hidden = false;
      if (def) def.hidden = true;
      setText('[data-lf-sent-offer]', res.offerNo || '');
      setText('[data-lf-sent-email]', email || '');
    } else {
      setText('[data-lf-sent-title]', 'Danke – Ihre Anfrage ist da.');
      if (mailed) mailed.hidden = true;
      if (def) def.hidden = false;
    }
    scrollToPanel();
    try { sent.focus({ preventScroll: true }); } catch (e) {}
  }

  /* Notfall-Weg: Felder ins versteckte Shopify-Kontaktformular kopieren und absenden */
  function fallbackSubmit(form) {
    var fb = $('.lf-fallback');
    if (!fb) return;
    $$('[data-lf-copied]', fb).forEach(function (x) { x.remove(); });
    new FormData(form).forEach(function (value, name) {
      if (name.indexOf('contact[') !== 0 || typeof value !== 'string') return;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      input.setAttribute('data-lf-copied', '');
      fb.appendChild(input);
    });
    st.sending = true;
    render();
    if (typeof fb.requestSubmit === 'function') fb.requestSubmit(); else fb.submit();
  }

  /* ------------------------------------------------------------------ Videocall (Calendly, erst nach Klick laden) */
  function openCalendly() {
    var box = $('[data-lf-cal]');
    if (!box || !cfg.calendly) return;
    var u;
    try { u = new URL(cfg.calendly); } catch (e) { return; }
    if (!/(^|\.)calendly\.com$/.test(u.hostname)) { window.open(cfg.calendly, '_blank', 'noopener'); return; }
    u.searchParams.set('embed_domain', location.hostname);
    u.searchParams.set('embed_type', 'Inline');
    u.searchParams.set('hide_gdpr_banner', '1');
    if (st.who.name) u.searchParams.set('name', st.who.name);
    if (st.who.email) u.searchParams.set('email', st.who.email);
    var f = document.createElement('iframe');
    f.src = u.toString();
    f.title = 'Videocall-Termin wählen';
    f.className = 'lf-cal__frame';
    f.setAttribute('allow', 'payment');
    box.innerHTML = '';
    box.appendChild(f);
    box.hidden = false;
    $$('[data-lf-cal-open], [data-lf-cal-note]').forEach(function (x) { x.hidden = true; });
    track('lk_termin_open');
  }
  window.addEventListener('message', function (e) {
    if (!/^https:\/\/([a-z0-9-]+\.)?calendly\.com$/.test(e.origin || '') || !e.data || typeof e.data.event !== 'string') return;
    if (e.data.event === 'calendly.page_height' && e.data.payload && e.data.payload.height) {
      var h = parseInt(e.data.payload.height, 10);
      $$('.lf-cal__frame').forEach(function (f) { if (h > 300) f.style.height = (h + 10) + 'px'; });
    }
    if (e.data.event === 'calendly.event_scheduled') {
      track('lk_termin_gebucht');
      setText('[data-lf-sent-title]', 'Perfekt – Ihr Termin steht.');
    }
  });

  /* ------------------------------------------------------------------ Konfiguration speichern (nur E-Mail) */
  function saveDlg() { return $('[data-lf-save-dlg]'); }
  function openSave() {
    var d = saveDlg();
    if (!d) return;
    var form = $('[data-lf-save-form]', d), done = $('[data-lf-save-done]', d), mail = $('[data-lf-save-email]', d);
    if (form) form.hidden = false;
    if (done) done.hidden = true;
    var formMail = $('[data-lf-form] input[type=email]');
    if (mail && !mail.value && formMail && formMail.value) mail.value = formMail.value;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    setTimeout(function () { if (mail) try { mail.focus(); } catch (e) {} }, 30);
    track('lk_save_open');
  }
  function closeSave() { var d = saveDlg(); if (!d) return; if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open'); }
  function submitSave(e) {
    e.preventDefault();
    var d = saveDlg();
    var mail = $('[data-lf-save-email]', d), err = $('[data-lf-save-error]', d), btn = $('[data-lf-save-submit]', d), hp = $('[data-lf-save-hp]', d);
    if (!mail || !mail.checkValidity() || !mail.value) { if (mail) { mail.focus(); if (mail.reportValidity) mail.reportValidity(); } return; }
    if (!cfg.saveApi) return;
    err.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Wird gesendet …';
    var src = $('[data-lf-source]');
    fetch(cfg.saveApi, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: mail.value, hp: hp ? hp.value : '', konfiguration: konfig(), seite: window.location.href, quelle: src ? src.value : '' })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok || !b.ok) throw new Error(b.error || 'Fehler ' + r.status); });
    }).then(function () {
      $('[data-lf-save-form]', d).hidden = true;
      $('[data-lf-save-done]', d).hidden = false;
      setText('[data-lf-save-to]', mail.value);
      track('lk_entwurf', { konfiguration: konfigCode(konfig()) });
    }).catch(function (x) {
      err.hidden = false;
      err.textContent = x && x.message && !/^Fehler|Failed to fetch|NetworkError/.test(x.message) ? x.message : 'Das hat nicht geklappt – bitte versuchen Sie es gleich noch einmal.';
    }).then(function () { btn.disabled = false; btn.textContent = 'Link per E-Mail senden'; });
  }

  /* ------------------------------------------------------------------ Bewertungen (Judge.me) */
  function initReviews() {
    var sec = $('[data-lf-reviews]');
    if (!sec || sec.__lf) return;
    sec.__lf = true;
    var trackEl = $('[data-lf-rail-track]', sec);
    var shop = sec.getAttribute('data-shop');
    if (!trackEl || !shop) return;
    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      fetchAll(shop).then(function (list) {
        if (!list.length) throw new Error('leer');
        renderReviews(sec, trackEl, list);
      }).catch(function () {
        $$('.lf-review--skel', trackEl).forEach(function (x) { x.remove(); });
        var fb = $('[data-lf-reviews-fallback]', sec);
        if (fb) fb.hidden = false;
        var nav = $('.lf-rail__nav', sec);
        if (nav) nav.hidden = true;
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '900px 0px' });
      io.observe(sec);
    } else load();
    initRailNav(sec, trackEl);
  }

  function fetchPage(shop, page) {
    var url = 'https://judge.me/reviews/all_reviews_js_based?shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + page;
    return fetch(url).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  function parseReviews(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    return $$('.jdgm-rev', doc).map(function (r) {
      var get = function (s) { var x = r.querySelector(s); return x ? x.textContent.replace(/\s+/g, ' ').trim() : ''; };
      var sc = r.querySelector('[data-score]');
      var ts = r.querySelector('.jdgm-rev__timestamp');
      var body = r.querySelector('.jdgm-rev__body');
      return {
        id: r.getAttribute('data-review-id') || '',
        score: sc ? parseInt(sc.getAttribute('data-score'), 10) || 5 : 5,
        author: get('.jdgm-rev__author'),
        title: get('.jdgm-rev__title'),
        body: body ? body.textContent.replace(/\s+/g, ' ').trim() : '',
        product: get('.jdgm-rev__prod-link'),
        date: ts ? (ts.getAttribute('data-content') || '') : ''
      };
    }).filter(function (x) { return x.body || x.title; });
  }
  function fetchAll(shop) {
    var all = [], seen = {};
    function next(page) {
      return fetchPage(shop, page).then(function (data) {
        var list = parseReviews(data && data.html);
        var added = 0;
        list.forEach(function (rv) { var k = rv.id || rv.author + rv.title; if (!seen[k]) { seen[k] = 1; all.push(rv); added++; } });
        var total = (Number(data && data.number_of_product_reviews) || 0) + (Number(data && data.number_of_shop_reviews) || 0);
        if (added && all.length < total && page < 8) return next(page + 1);
        return all;
      });
    }
    return next(1);
  }

  function renderReviews(sec, trackEl, list) {
    // Bewertungen zu Messeständen/Theken zuerst (passen zur Suchintention), dann nach Datum
    var rel = /messestand|stand|theke|counter/i;
    list.sort(function (a, b) {
      var ra = rel.test(a.product) ? 0 : 1, rb = rel.test(b.product) ? 0 : 1;
      if (ra !== rb) return ra - rb;
      return (b.date || '').localeCompare(a.date || '');
    });
    trackEl.innerHTML = '';
    list.forEach(function (rv) {
      var card = el('article', 'lf-review');
      card.setAttribute('aria-label', 'Bewertung von ' + (rv.author || 'Kunde'));
      card.insertAdjacentHTML('beforeend', starsHtml(rv.score));
      if (rv.title) card.appendChild(el('h3', 'lf-review__title', rv.title));
      var body = el('p', 'lf-review__body', rv.body);
      card.appendChild(body);
      var more = el('button', 'lf-review__more', 'Weiterlesen');
      more.type = 'button';
      more.hidden = true;
      more.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        more.textContent = open ? 'Weniger' : 'Weiterlesen';
      });
      card.appendChild(more);
      var foot = el('div', 'lf-review__foot');
      foot.appendChild(el('span', 'lf-review__av', (rv.author || '?').replace(/^(Fr\.|Hr\.|Herr|Frau)\s*/i, '').charAt(0).toUpperCase()));
      var who = el('div', 'lf-review__who');
      who.appendChild(el('span', 'lf-review__name', rv.author || 'Kunde'));
      var meta = [];
      if (rv.product) meta.push(rv.product);
      if (rv.date) {
        var dt = new Date(rv.date.replace(' UTC', 'Z').replace(' ', 'T'));
        if (!isNaN(dt.getTime())) meta.push(dt.toLocaleDateString('de-DE', { month: 'short', year: 'numeric' }));
      }
      who.appendChild(el('span', 'lf-review__meta', meta.join(' · ')));
      foot.appendChild(who);
      card.appendChild(foot);
      trackEl.appendChild(card);
    });
    // „Weiterlesen“ nur, wo der Text wirklich gekürzt ist
    requestAnimationFrame(function () {
      $$('.lf-review', trackEl).forEach(function (c) {
        var b = $('.lf-review__body', c), m = $('.lf-review__more', c);
        if (b && m) m.hidden = b.scrollHeight <= b.clientHeight + 2;
      });
    });
    var five = list.filter(function (r) { return r.score === 5; }).length;
    setText('[data-lf-reviews-detail]', five + ' von ' + list.length + ' mit 5 Sternen');
    trackEl.dispatchEvent(new Event('scroll'));
  }

  function starsHtml(score) {
    var pct = Math.max(0, Math.min(100, score * 20));
    var path = 'M9 1.2l2.3 4.7 5.2.8-3.8 3.7.9 5.2L9 13.1l-4.6 2.5.9-5.2L1.5 6.7l5.2-.8z';
    var row = '';
    for (var i = 0; i < 5; i++) row += '<path transform="translate(' + (i * 18.8) + ' 0)" d="' + path + '"/>';
    return '<span class="lf-stars lf-stars--sm" role="img" aria-label="' + score + ' von 5 Sternen">' +
      '<svg viewBox="0 0 94 17" fill="#e3e3e8" aria-hidden="true">' + row + '</svg>' +
      '<span class="lf-stars__fill" style="width:' + pct + '%"><svg viewBox="0 0 94 17" fill="#f5a623" aria-hidden="true">' + row + '</svg></span></span>';
  }

  function initRailNav(sec, trackEl) {
    var prev = $('[data-lf-rail-prev]', sec), next = $('[data-lf-rail-next]', sec);
    if (!prev || !next) return;
    function stepW() { var c = trackEl.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 320; }
    function upd() {
      prev.disabled = trackEl.scrollLeft < 8;
      next.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 8;
    }
    prev.addEventListener('click', function () { trackEl.scrollBy({ left: -stepW(), behavior: reduceMotion() ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { trackEl.scrollBy({ left: stepW(), behavior: reduceMotion() ? 'auto' : 'smooth' }); });
    trackEl.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ------------------------------------------------------------------ Galerie & Lightbox */
  var gallery = [], lbList = null, lbIdx = null;
  function initGallery() {
    var data = document.getElementById('lf-gallery-data');
    if (data) { try { gallery = JSON.parse(data.textContent) || []; } catch (e) { gallery = []; } }
    $$('[data-lf-open]').forEach(function (b) {
      if (b.__lf) return; b.__lf = true;
      b.addEventListener('click', function () { openLb(null, parseInt(b.getAttribute('data-lf-open'), 10)); track('lk_gallery_open'); });
    });
    $$('[data-lf-photos]').forEach(function (b) {
      if (b.__lf) return; b.__lf = true;
      b.addEventListener('click', function () {
        if (!gallery.length) { gotoTarget('referenzen'); return; }
        var match = [], rest = [];
        gallery.forEach(function (g, i) { (g.typ === st.typ ? match : rest).push(i); });
        openLb(match.concat(rest), 0);
        track('lk_photos_open', { typ: st.typ });
      });
    });
    var lb = $('[data-lf-lb]');
    if (!lb || lb.__lf) return;
    lb.__lf = true;
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    $('[data-lf-lb-close]', lb).addEventListener('click', closeLb);
    $('[data-lf-lb-prev]', lb).addEventListener('click', function () { stepLb(-1); });
    $('[data-lf-lb-next]', lb).addEventListener('click', function () { stepLb(1); });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 45) stepLb(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (lbIdx === null) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') stepLb(1);
      if (e.key === 'ArrowLeft') stepLb(-1);
    });
  }
  function lbItems() { return lbList ? lbList.map(function (i) { return gallery[i]; }) : gallery; }
  function openLb(list, idx) { lbList = list; lbIdx = idx; drawLb(); }
  function closeLb() { lbIdx = null; drawLb(); }
  function stepLb(dir) { var n = lbItems().length; if (lbIdx === null || !n) return; lbIdx = (lbIdx + dir + n) % n; drawLb(); }
  var lastFocus = null;
  function drawLb() {
    var lb = $('[data-lf-lb]');
    if (!lb) return;
    if (lbIdx === null) {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
      return;
    }
    if (lb.hidden) lastFocus = document.activeElement;
    var items = lbItems(), it = items[lbIdx] || {};
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var img = $('img', lb);
    if (img) { img.src = it.src || ''; img.alt = it.caption || 'Messestand eines Kunden'; }
    setText('[data-lf-lb-cap]', it.caption || '');
    setText('[data-lf-lb-count]', (lbIdx + 1) + ' / ' + items.length);
    $$('[data-lf-lb-prev], [data-lf-lb-next]', lb).forEach(function (b) { b.hidden = items.length < 2; });
    [1, -1].forEach(function (o) { var n = items[(lbIdx + o + items.length) % items.length]; if (n && n.src) { var p = new Image(); p.src = n.src; } });
    try { $('[data-lf-lb-close]', lb).focus({ preventScroll: true }); } catch (e) {}
  }

  /* ------------------------------------------------------------------ Video */
  function initVideo() {
    $$('[data-lf-video]').forEach(function (holder) {
      var btn = $('[data-lf-play]', holder);
      if (!btn || btn.__lf) return;
      btn.__lf = true;
      btn.addEventListener('click', function () {
        var src = holder.getAttribute('data-src');
        if (!src) return;
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
        v.setAttribute('playsinline', '');
        var poster = holder.getAttribute('data-poster');
        if (poster) v.poster = poster;
        holder.innerHTML = '';
        holder.appendChild(v);
        try { v.play(); } catch (e) {}
        track('lk_video_play');
      });
    });
  }

  /* ------------------------------------------------------------------ Events */
  function bind() {
    var started = false;
    function startOnce() { konfigTouched = true; if (!started) { started = true; track('lk_konfig_start'); } }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.matches('[data-lf-typ]')) { st.typ = t.value; startOnce(); render(); }
      else if (t.matches('[data-lf-breite]')) {
        st.breite = parseInt(t.value, 10);
        if (st.breite <= 6) st.xlOpen = false; else track('lk_sonderlaenge', { breite: st.breite });
        startOnce(); render();
      }
      else if (t.matches('[data-lf-tiefe]')) { if (st.typ !== 'kopf') st.tiefen[st.typ] = parseInt(t.value, 10); startOnce(); render(); }
      else if (t.matches('[data-lf-theke]')) { st.theke = t.value; startOnce(); render(); }
      else if (t.matches('[data-lf-theke-n]')) { st.thekeN = parseInt(t.value, 10) || 1; render(); track('lk_theken', { anzahl: st.thekeN }); }
      else if (t.matches('[data-lf-kab-t]')) { st.kabT = parseInt(t.value, 10) || 1; render(); track('lk_kabine_groesse', { tiefe: st.kabT }); }
      else if (t.matches('[data-lf-addon="br"]')) { st.br = t.checked; startOnce(); render(); }
      else if (t.matches('[data-lf-addon="kab"]')) { st.kab = t.checked; startOnce(); render(); }
      else if (t.matches('[data-lf-addon="tv"]')) { st.tv = t.checked; startOnce(); render(); }
      else if (t.matches('[data-lf-file]')) { readFile(t.files && t.files[0]); }
      else if (t.matches('[data-lf-logo-file]')) { readLogo(t.files && t.files[0]); }
      else if (t.matches('[data-lf-messe]')) {
        st.messe = t.value; render();
        var res = lieferCheck(st.messe);
        if (res) track('lk_liefercheck', { status: res.s });
      }
    });
    document.addEventListener('input', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('[data-lf-messe]')) { st.messe = e.target.value; render(); }
      if (e.target.matches('[data-lf-form] input[type=email]')) suggestWebsite(e.target.value);
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-lf-breite-more], [data-lf-goto], [data-lf-goto-step], [data-lf-stepbtn], [data-lf-next], [data-lf-light], [data-lf-masse], [data-lf-mirror], [data-lf-demo], [data-lf-track], [data-lf-preset], [data-lf-save-open], [data-lf-save-close], [data-lf-cal-open]') : null;
      if (!t) return;
      if (t.hasAttribute('data-lf-preset')) {
        applyConfig(presetOf(t));
        if (!started) { started = true; track('lk_konfig_start'); }
        track('lk_preset', { name: t.getAttribute('data-lf-preset-name') || '' });
        st.step = 1;
        render();
        gotoTarget('konfigurator');
        return;
      }
      if (t.hasAttribute('data-lf-save-open')) { openSave(); return; }
      if (t.hasAttribute('data-lf-breite-more')) {
        if (st.breite > 6) { st.xlOpen = true; render(); return; }
        st.xlOpen = !st.xlOpen; render();
        if (st.xlOpen) track('lk_sonderlaenge_open');
        return;
      }
      if (t.hasAttribute('data-lf-save-close')) { closeSave(); return; }
      if (t.hasAttribute('data-lf-cal-open')) { openCalendly(); return; }
      if (t.hasAttribute('data-lf-track')) track('lk_contact_click', { method: t.getAttribute('data-lf-track') });
      if (t.hasAttribute('data-lf-goto')) { e.preventDefault(); gotoTarget(t.getAttribute('data-lf-goto')); return; }
      if (t.hasAttribute('data-lf-goto-step')) { goStep(parseInt(t.getAttribute('data-lf-goto-step'), 10), { scroll: true, focus: true }); return; }
      if (t.hasAttribute('data-lf-stepbtn')) { goStep(parseInt(t.getAttribute('data-lf-stepbtn'), 10), { focus: true }); return; }
      if (t.hasAttribute('data-lf-next')) { goStep(st.step + 1, { scroll: true, focus: true }); return; }
      if (t.hasAttribute('data-lf-light')) { st.licht = !st.licht; render(); return; }
      if (t.hasAttribute('data-lf-masse')) { st.masse = !st.masse; if (st.masse) track('lk_masse_on'); render(); return; }
      if (t.hasAttribute('data-lf-mirror')) { st.spiegeln = !st.spiegeln; if (st.spiegeln) track('lk_spiegeln_on'); render(); return; }
      if (t.hasAttribute('data-lf-demo')) { st.img = t.getAttribute('data-lf-demo'); st.imgDemo = true; render(); return; }
    });

    var form = $('[data-lf-form]');
    if (form) form.addEventListener('submit', submit);
    var sf = $('[data-lf-save-form]');
    if (sf) sf.addEventListener('submit', submitSave);
    var dlg = saveDlg();
    if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) closeSave(); });
    if (!cfg.saveApi) $$('[data-lf-save-open]').forEach(function (b) { b.hidden = true; });

    var stage = $('[data-lf-stage]');
    if (stage) {
      stage.addEventListener('dragover', function (e) { e.preventDefault(); stage.classList.add('is-drag'); });
      stage.addEventListener('dragleave', function () { stage.classList.remove('is-drag'); });
      stage.addEventListener('drop', function (e) {
        e.preventDefault(); stage.classList.remove('is-drag');
        readFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
      });
    }
  }

  /* ------------------------------------------------------------------ Start */
  function init() {
    // Anfrage über den Notfall-Weg schon gesendet (Seite nach Shopify-Formular neu geladen)
    var sent = $('[data-lf-sent]');
    if (sent && !sent.hidden) st.sent = true;
    if (location.hash === '#angebot') st.step = 3;
    // Link aus „Konfiguration speichern“ / Vorlage: ?konfig=eck-5x3-one2-br-kab2-tv
    try {
      var kc = new URLSearchParams(location.search).get('konfig');
      if (kc && P() && P().decodeKonfig) { var dk = P().decodeKonfig(kc); if (dk) { applyConfig(dk); track('lk_konfig_link'); } }
    } catch (e) {}
    fillFromPrices();
    fillSource();
    bind();
    render();
    initBar();
    initReviews();
    initGallery();
    initVideo();
    if (location.hash === '#angebot') setTimeout(function () { scrollToPanel(); }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme-Editor: neu geladene Sections nachrüsten
  document.addEventListener('shopify:section:load', function () { fillFromPrices(); render(); initReviews(); initGallery(); initVideo(); });
})();
